import { addSideEffects } from '@poa/state';
import { fetchContactInfo, refreshContactInfo, changeFilter } from './contact-info.actions';

addSideEffects(fetchContactInfo, async (_, { actions, env, store }) => {
  try {
    const contactInfoGrouping = await env.api.contactInfo.fetchContactInfoGrouping();
    actions.contactInfoActions.resetGrouping(contactInfoGrouping);

    const contactInfo = await env.api.contactInfo.fetchContactInfo(
      store.contactInfo.filters.filter
    );
    actions.contactInfoActions.fetchContactInfoSuccess(contactInfo);
  } catch (e) {
    console.error(e);
    actions.contactInfoActions.fetchContactInfoFailed();
    throw e;
  }
});

addSideEffects(refreshContactInfo, async (_, { actions, env, store }) => {
  const contactInfo = await env.api.contactInfo.fetchContactInfo(store.contactInfo.filters.filter);

  actions.contactInfoActions.fetchContactInfoSuccess(contactInfo);
});

addSideEffects(changeFilter, async ({ filter }, { actions, env }) => {
  try {
    const contactInfo = await env.api.contactInfo.fetchContactInfo(filter);
    actions.contactInfoActions.fetchContactInfoSuccess(contactInfo);
  } catch (e) {
    console.error(e);
    actions.contactInfoActions.fetchContactInfoFailed();
    throw e;
  }
});
